/**
 * Reine FO/BO-Verantwortlichkeits-Ableitungen (SP6), DOM-frei testbar
 * (vitest `environment: node`). Die Präsentation lebt in `foBo.tsx`.
 */

/** Initialen (2 Zeichen) aus einem Namen für den FO-Kreis. */
export function initials(name: string): string {
    const words = name.split(/[\s,]+/).filter(Boolean);
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return (words[0] ?? "").slice(0, 2).toUpperCase();
}

/** Deterministische, stabile Farbe pro Entity (Hash → HSL: heller bg, dunkler fg). */
export function hashColor(s: string): { bg: string; fg: string } {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    const hue = ((h % 360) + 360) % 360;
    return { bg: `hsl(${hue} 55% 90%)`, fg: `hsl(${hue} 55% 32%)` };
}

export interface FoBoTeam {
    id?: string | null;
    name?: string | null;
}
export interface FoBoUser {
    userId?: string | null;
    kuerzel?: string | null;
    displayName?: string | null;
}

/**
 * Reine Ableitung der Anzeige-Labels:
 *  - `boLabel` = Team-Name ohne führendes „Team " (z. B. „Team CLL" → „CLL"),
 *  - `foLabel` = Kürzel (z. B. „MaF"), sonst Namens-Initialen; jeweils `null`,
 *    wenn nichts gesetzt ist.
 */
export function foBoLabels(
    boTeam?: FoBoTeam | null,
    foUser?: FoBoUser | null,
): { boLabel: string | null; foLabel: string | null } {
    const boName = boTeam?.name?.trim() || null;
    const foName = foUser?.displayName?.trim() || null;
    const foKuerzel = foUser?.kuerzel?.trim() || null;
    const boLabel = boName ? boName.replace(/^Team\s+/i, "") : null;
    const foLabel = foKuerzel || (foName ? initials(foName) : null);
    return { boLabel, foLabel };
}
